unique.offerProductSearch = {
    debug: false,
    jProductList: jQuery( '.js-unique-offer-product-search' ),
    init: function () {
        if ( unique.offerProductSearch.jProductList.length === 1 ) {
            unique.offerProductSearch.bindEvents();
        }
    },
    bindEvents: function () {
        jQuery( document ).on( 'input', '.js-unique-offer-product-search-facet-option-search-input', e4.util.debounce( function ( objEvent ) {
            unique.offerProductSearch.facets.searchFacetGroupOptions( objEvent.target );
        }, e4.settings.debounceDelay.input ) ).on( 'change', '.js-unique-offer-product-search-facet-option-input', function ( objEvent ) {
            unique.offerProductSearch.facets.apply( objEvent.target );
        } );
        jQuery( '.js-unique-offer-product-search-page-size-input' ).on( 'change', function ( objEvent ) {
            console.log( 'set page size', jQuery( objEvent.target ).val() );
            unique.offerProductSearch.pageSize.set( jQuery( objEvent.target ).val() );
            unique.offerProductSearch.loadProductsAndFacets();
        } );
        unique.offerProductSearch.jProductList.on( 'submit', '.js-unique-offer-product-search-form', function ( event ) {
            event.preventDefault();
            unique.offerProductSearch.facets.apply( event.target );
        } );
        unique.offerProductSearch.jProductList.on( 'keydown keypress', '.js-unique-offer-product-search-facet-option-input[type="text"]', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                unique.offerProductSearch.facets.apply( event.target );
            }
        } );
        unique.offerProductSearch.jProductList.on( 'click', '.js-unique-offer-product-search-clear-selected-facet-option-btn', function ( event ) {
            event.preventDefault();
            unique.offerProductSearch.facets.clearSelectedFacetOption( event.currentTarget );
        } );
        unique.offerProductSearch.jProductList.on( 'click', '.js-unique-offer-product-search-clear-all-selected-facet-options-btn', function ( event ) {
            event.preventDefault();
            unique.offerProductSearch.facets.clearAllSelectedFacetOptions();
        } );
        unique.offerProductSearch.jProductList.on( 'click', '.js-unique-offer-product-search-products-add-all-to-offer-btn', function ( event ) {
            event.preventDefault();
            unique.offerProductSearch.products.addAllToOffer();
        } );
    },
    ajax: function ( objAjaxSettings ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            method: 'GET',
            dataType: 'json',
            url: unique.offerProductSearch.getFeedUrl(),
            cache: false,
            data: unique.offerProductSearch.getParamsFromForm(),
        }, objAjaxSettings ) );

        jqXHR.fail( function ( jqXHR, textStatus, errorThrown ) {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products' ).html( '<h4>' + errorThrown + '</h4>' );
        } );
        jqXHR.always( function () {
            e4.loading.resolveWait( '.js-unique-offer-product-search' );
            unique.offerProductSearch.jProductList.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
        } );
        return jqXHR;
    },
    loadProductsAndFacets: function () {
        if ( unique.offerProductSearch.jProductList.length === 1 ) {
            unique.offerProductSearch.jProductList.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            return unique.offerProductSearch.ajax( {} ).done( function ( jsonData ) {
                unique.offerProductSearch.products.build( jsonData );
                unique.offerProductSearch.facets.build( jsonData );
            } );
        }
    },
    getFeedUrl: function () {
        var strReturnValue = e4.settings.offer.productSearchUrl,
            strCustomUrl = unique.offerProductSearch.jProductList.data( 'feed-url' );
        if ( unique.utilities.looksLikeUrl( strCustomUrl ) === true ) {
            strReturnValue = strCustomUrl;
        }
        strReturnValue += ( strReturnValue.includes( '?' ) === true ? '&' : '?' ) + 'includeFacets=true';
        return strReturnValue;
    },
    getParamsFromForm: function () {
        return unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-form' ).serialize();
    },
    pageSize: {
        set: function ( intPageSize ) {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-form' ).find( '[name="PageSize"]' ).val( intPageSize );
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-page-size-input' ).filter( '[value="' + intPageSize + '"]' ).prop( 'checked', true );
        },
        show: function () {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products-page-size' ).removeClass( 'd-none' );
        },
        hide: function () {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products-page-size' ).addClass( 'd-none' );
        },
    },
    addAllButton: {
        show: function () {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products-add-all-to-offer' ).removeClass( 'd-none' );
        },
        hide: function () {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products-add-all-to-offer' ).addClass( 'd-none' );
        },
    },
    products: {
        build: function ( jsonData ) {
            var jProductContainer = unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products' );
            if ( jsonData.facets !== null && jsonData.facets.selectedFacetOptionsCount > 0 ) {
                if ( jsonData.products === null || jsonData.products.length < 1 ) {
                    jProductContainer.empty();
                    unique.offerProductSearch.pageSize.hide();
                    unique.offerProductSearch.addAllButton.hide();
                    unique.offerProductSearch.products.showAlert();
                }
                else {
                    unique.offerProductSearch.products.hideAlert();
                    unique.offerProductSearch.pageSize.show();
                    unique.offerProductSearch.addAllButton.show();
                    jQuery( '.js-unique-offer-product-search-products-count' ).html( jsonData.list.productCount );
                    var strItemClasses = jProductContainer.data( 'item-classes' ),
                        arrProductsHtml = jQuery.map( jsonData.products, function ( objProduct ) {
                            return unique.offerProductSearch.products.getListItemHtmlWithItemClasses( objProduct.listItemHtml, strItemClasses );
                        } );
                    jProductContainer.html( arrProductsHtml.join( '' ) );
                }

            }
            else {
                unique.offerProductSearch.products.hideAlert();
                unique.offerProductSearch.addAllButton.hide();
                unique.offerProductSearch.pageSize.hide();
                jProductContainer.empty();
            }
        },
        getListItemHtmlWithItemClasses: function ( strListItemHtml, strItemClasses ) {
            return '<div class="' + strItemClasses + '">' + strListItemHtml + '</div>';
        },
        showAlert: function () {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products-alert' ).removeClass( 'd-none' );
        },
        hideAlert: function () {
            unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products-alert' ).addClass( 'd-none' );
        },
        addAllToOffer: function () {
            var arrProductAddToOfferForms = unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-products' ).find( '.js-unique-add-product-to-offer-form' ).toArray();
            unique.offer.addMultipleProductsByForm( arrProductAddToOfferForms );
        }
    },
    facets: {
        build: function ( jsonData ) {
            if ( jsonData.facets !== null ) {
                jQuery( '.js-unique-offer-product-search-facets' ).html( jsonData.facets.html );
                jQuery( '.js-unique-offer-product-search-selected-facet-options-count' ).html( jsonData.facets.selectedFacetOptionsCount === 0 ? '' : jsonData.facets.selectedFacetOptionsCount );
            }
        },
        apply: function () {
            unique.offerProductSearch.pageSize.set( unique.offerProductSearch.jProductList.data( 'page-size' ) );
            unique.offerProductSearch.loadProductsAndFacets();
        },
        clearSelectedFacetOption: function ( domNode ) {
            var jNode = jQuery( domNode ),
                strFacetParameterName = jNode.data( 'facet-parameter-name' ),
                strFacetOptionValue = jNode.data( 'facet-option-value' ),
                jSelectedFacetOptionInput = unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-facet-option-input[name="' + strFacetParameterName + '"][value="' + strFacetOptionValue + '"]' );
            if ( jSelectedFacetOptionInput.attr( 'type' ) === 'text' ) {
                jSelectedFacetOptionInput.val( '' );
            }
            else {
                jSelectedFacetOptionInput.prop( 'checked', false );
            }
            console.log( 'clearSelectedFacetOption', strFacetParameterName, strFacetOptionValue );
            unique.offerProductSearch.facets.apply();
        },
        clearAllSelectedFacetOptions: function () {
            var jSelectedFacetOptionInputs = unique.offerProductSearch.jProductList.find( '.js-unique-offer-product-search-facet-option-input' );
            jSelectedFacetOptionInputs.filter( '[type="checkbox"]' ).prop( 'checked', false );
            jSelectedFacetOptionInputs.filter( '[type="text"]' ).val( '' );
            //console.log( 'clearAllSelectedFacetOptions', jSelectedFacetOptionInputs );
            unique.offerProductSearch.facets.apply();
        },
        searchFacetGroupOptions: function ( domNode ) {
            var jInput = jQuery( domNode ),
                strSearchQuery = jInput.val().trim().toLowerCase(),
                jOptions = jInput.closest( '.js-unique-offer-product-search-facet-group' ).find( '.js-unique-offer-product-search-facet-option' );
            if ( strSearchQuery.length > 0 ) {
                jOptions.each( function ( intIndex, domNode ) {
                    var jOption = jQuery( domNode ),
                        strOptionValue = e4.util.stringify( jOption.find( 'input' ).data( 'label' ) ).trim().toLowerCase();
                    if ( strOptionValue.indexOf( strSearchQuery ) > -1 ) {
                        jOption.removeClass( 'd-none' );
                    }
                    else {
                        jOption.addClass( 'd-none' );
                    }
                } );
            }
            else {
                jOptions.removeClass( 'd-none' );
            }
        },
    },
}; 
